/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Showcase_EyebrowInputs */

const en_features_showcase_eyebrow = /** @type {(inputs: Features_Showcase_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the app does`)
};

const pl_features_showcase_eyebrow = /** @type {(inputs: Features_Showcase_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co potrafi aplikacja`)
};

/**
* | output |
* | --- |
* | "What the app does" |
*
* @param {Features_Showcase_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_showcase_eyebrow = /** @type {((inputs?: Features_Showcase_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Showcase_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_showcase_eyebrow(inputs)
	return en_features_showcase_eyebrow(inputs)
});